import React, { useEffect, useId } from "react";
import Pagination from "react-bootstrap/Pagination";
import PropTypes from "prop-types";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const PAGE_SELECTOR_MIN_PAGES = 4;

const PaginationComponent = ({
  pagesCountServer
  , currentPage
  , setCurrentPage
  , alwaysShown = true
  , setPagination
}) => {
  const pageSelectorId = useId();
  const pagesCount = pagesCountServer;
  const isPaginationShown = alwaysShown ? true : pagesCount > 1;
  const isPageSelectorShown = pagesCount >= PAGE_SELECTOR_MIN_PAGES;
  const isCurrentPageFirst = currentPage === 0;
  const isCurrentPageLast = currentPage === pagesCount - 1;
  const changePage = number => {
    if (currentPage === number) return;
    setCurrentPage(number);
    setPagination(values => ({
      ...values
      , pageIndex: number
    }));
  };

  const onPageNumberClick = pageNumber => {
    changePage(pageNumber - 1);
  };

  const onPreviousPageClick = () => {
    changePage(currentPage - 1);
  };

  const onNextPageClick = () => {
    changePage(currentPage + 1);
  };

  useEffect(() => {
    if (pagesCount > 0 && currentPage >= pagesCount) {
      const lastPage = pagesCount - 1;
      setCurrentPage(lastPage);
      setPagination(values => ({
        ...values
        , pageIndex: lastPage
      }));
    }
  }, [currentPage, pagesCount, setCurrentPage, setPagination]);

  let isPageNumberOutOfRange;

  const pageNumbers = [...new Array(pagesCount)].map((_, index) => {
    const pageNumber = index + 1;
    const isPageNumberFirst = pageNumber === 1;
    const isPageNumberLast = pageNumber === pagesCount;
    const isCurrentPageWithinTwoPageNumbers =
      Math.abs(pageNumber - currentPage) <= 2;
    if (
      isPageNumberFirst ||
      isPageNumberLast ||
      isCurrentPageWithinTwoPageNumbers
    ) {
      isPageNumberOutOfRange = false;

      return (
        <Pagination.Item
          key={pageNumber}
          onClick={() => onPageNumberClick(pageNumber)}
          active={pageNumber === currentPage + 1}
        >
          {pageNumber}
        </Pagination.Item>
      );
    }

    if (!isPageNumberOutOfRange) {
      isPageNumberOutOfRange = true;
      return <Pagination.Ellipsis key={pageNumber} className="muted" />;
    }

    return null;
  });

  return (
    <>
      {isPaginationShown && (
        <Container>
          <Row>
            <Col className="d-flex justify-content-center align-items-center gap-3 mt-3">
              <span className="fs-6 text-pewter-blue">Mostrando {currentPage + 1}  de {pagesCount}</span>
            </Col>
          </Row>
          <Row>
            <Col className="d-flex justify-content-center align-items-center gap-3 mt-2">
              <Pagination className="mb-0">
                <Pagination.Prev
                  onClick={onPreviousPageClick}
                  disabled={isCurrentPageFirst}
                />
                {pageNumbers}
                <Pagination.Next
                  onClick={onNextPageClick}
                  disabled={isCurrentPageLast}
                />
              </Pagination>
              {isPageSelectorShown && (
                <div className="d-flex align-items-center gap-2">
                  <label htmlFor={pageSelectorId} className="fs-6 text-pewter-blue text-nowrap">
                    Ir a página:
                  </label>
                  <select
                    id={pageSelectorId}
                    className="form-select form-select-sm w-auto pagination-page-selector"
                    value={currentPage + 1}
                    onChange={event => changePage(Number(event.target.value) - 1)}
                  >
                    {Array.from({ length: pagesCount }, (_, index) => (
                      <option key={index + 1} value={index + 1}>
                        {index + 1}
                      </option>
                    ))}
                  </select>
                </div>
              )}
            </Col>
          </Row>
        </Container>

      )
      }
    </>
  );
};

PaginationComponent.propTypes = {
  currentPage: PropTypes.number.isRequired,
  setCurrentPage: PropTypes.func.isRequired,
  alwaysShown: PropTypes.bool
};

export default PaginationComponent;
